import { render, staticRenderFns } from "./dropzone.vue?vue&type=template&id=f21b80c6"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"
import style0 from "./dropzone.vue?vue&type=style&index=0&id=f21b80c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports